import { Box, Typography } from "@material-ui/core";
import React from "react";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";
import WarningIcon from "@material-ui/icons/WarningRounded";
import { Button } from "@packages/ui";
import brandColors from "@packages/ui/theme/colors";
import getBrandFromUrl from "src/utils/getBrandFromUrl";


const RentalExpiredPage = () => {
  const classes = useStyles();
  const brand = getBrandFromUrl().toLowerCase();
  return (
    <>
      <Box
        sx={{
          p: 4,
          textAlign: "center",
          fontFamily: "Ride",
          color: "#333",
          margin: "0 auto",
        }}
      >
        <div className={classes.flexContainer}>
          <h1 className={classes.title}>Vehicle Incident Report</h1>
        </div>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ paddingTop: "10px" }}
        >
          <WarningIcon color="primary" style={{ fontSize: "50px" }} />
          <Typography
            className={classes.descripe}
            variant="body1"
            style={{ marginLeft: "8px", textAlign: "center" }}
          >
            Sorry, this rental is no longer available for submitting or editing vehicle incident
            reports.
          </Typography>
        </Box>

        <br></br>
        <hr className={classes.breakLine} style={{ borderColor: brandColors[brand] }} />
        <br></br>

        <Box
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          style={{ maxWidth: "700px", margin: "0 auto" }}
        >
          <Typography className={classes.descripe} variant="body1" style={{ textAlign: "center" }}>
            To access existing vehicle incident reports, along with other rental documentation,
            please log into My Journey Portal.
          </Typography>
          <br></br>
          <Button
            // className={classes.wordFormat}
            variant="contained"
            style={{ marginTop: "15px", padding: "8px 32px" }}
            onClick={() => {
              window.location.href = "https://myjourney.hertz.com.au/login";
            }}
          >
            LOGIN MJP
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default RentalExpiredPage;
